import { TXGUISection } from "../../interfaces/gui/fields.interfaces";

export const ELEMENTS_GUI_FIELDS: TXGUISection = {
  "Thème & Couleurs": [
    {
      type: "color",
      name: "bgColor",
      label: "Couleur d'arriere plan",
    },
  ],
  "Taille & Espacements": [
    {
      type: "sizing",
      name: "width",
      label: "Largeur",
    },
    {
      type: "sizing",
      name: "height",
      label: "Hauteur",
    },
    {
      type: "sides",
      name: "margin",
      label: "Espace Externe (Margin)",
      units: ["px", "em", "%", "auto"],
    },
    {
      type: "sides",
      name: "padding",
      label: "Espace Interne (Padding)",
      units: ["px", "em", "%", "auto"],
    },
  ],
  "Bordures & Arrondis": [
    {
      type: "radius",
      name: "borderRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "border",
      name: "border",
      label: "Bordure",
      units: ["px", "em"],
    },
  ],
};
